<template>
	<bsh-modal
		titulo="Editar Entrega"
		:name="name">
		<template v-slot:default>
	        <entrega-form
				:dados="dados"
	        	:name="name"
	        	:errors="errors">
	        </entrega-form>
	    </template>
	    <template v-slot:footer>
        	<button
				ref="btnRequest"
        		type="button"
        		class="btn btn-primary"
        		@click="update">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		data(){
			return {
				dados: [],
				name: 'update_entrega',
				errors: []
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			update(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.put(this.$url+'/api/adm/entregas/update/'+this.$route.params.id, (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
        	getDados(){
	            axios.get(this.$url+'/api/adm/entregas/show/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			}
		}
	}
</script>
